import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import type { BusinessStatusEnumKey } from './generated/models/BusinessStatus';
import { BaseApiService } from './base-api.service';

export type CompleteBusinessSetupRequest = {
  name: string;
  status: Extract<BusinessStatusEnumKey, 'active'>;
};

export type BusinessSetupResponse = {
  id: string;
  name: string;
  slug: string;
  status: BusinessStatusEnumKey;
};

@Injectable({ providedIn: 'root' })
export class CoreBusinessApiService extends BaseApiService<BusinessSetupResponse> {
  protected override readonly resourcePath = '/v1/core/businesses';

  completeSetup(
    businessId: string,
    body: CompleteBusinessSetupRequest,
  ): Observable<BusinessSetupResponse> {
    return this.patch<BusinessSetupResponse, CompleteBusinessSetupRequest>(businessId, body);
  }
}
